// src/helpers/statusHelper.js

export function getStatusInfo(status) {
  const statusMap = {
    'registered': { title: 'Inscrit', color: 'bg-label-primary' },
    'started': { title: 'En cours', color: 'bg-label-primary' },
    'in-progress': { title: 'En cours', color: 'bg-label-warning' },
    'chapter-quiz': { title: 'En cours', color: 'bg-label-primary' },
    'final-quiz': { title: 'En cours', color: 'bg-label-primary' },
    'pending': { title: 'En attente de validation', color: 'bg-label-warning' },
    succeeded: { title: 'Terminé', color: 'alert-success' },
    failed: { title: 'Échoué', color: 'alert-danger' },
    other: { title: 'Inconnu', color: 'alert-secondary' },
  };

  // Retourne le titre et la couleur selon le statut
  return statusMap[status] || { title: 'Inconnu', color: 'bg-label-primary' };
}
